import {useContext} from 'react';
import {AppCtx} from '../../AppCtx';
import {getWorkspaceIdForSession} from '../services/dbUtils';
import {isWorkspaceReadOnly} from '../services/workspaceAccess';

export const useWorkspaceReadOnly = () => {
  const {currentSessionId} = useContext(AppCtx);
  return isWorkspaceReadOnly(getWorkspaceIdForSession(currentSessionId));
};
